import React from 'react';
import { List, ListItem, ListItemIcon, ListItemText, Divider } from "@mui/material";
import { Link } from "react-router-dom";
import { useSession } from '../../../hooks/auth.hook';
import { ProtectedRoutesConfig } from '../../../config/protected.routes';
import { MenuEntries } from '../../../config/menu.entries';

export function Menu() {
    const { user } = useSession();

    return (
        <List>
            {MenuEntries
                .filter(item => ProtectedRoutesConfig.find((entry) => entry.prefix === item.path)?.allowedRoles.includes(user!!.role_id!!))
                .map((item, index) => (
                    <React.Fragment key={item.text}>
                        <ListItem component={Link} to={item.path}>
                            <ListItemIcon>{item.icon}</ListItemIcon>
                            <ListItemText primary={item.text} />
                        </ListItem>
                        {index < MenuEntries.length - 1 && <Divider />}
                    </React.Fragment>
                ))}
        </List>
    );
}
